<!--<iframe src="https://www.kryptomon.co/token#swap"></iframe>-->
<div class="new-container">
  <div class="wallet-section">
    <div class="col-lg-12 col">
      <div class="balance-container">
        <div class="card wallet-card" [ngClass]="{'extend': cardExtend[0]}">
          <div class="balance-content">
            <img src="./assets/img/Home/k-logo.png" />
            <h1 class="title-gradient gradient-pp">{{kmonBalanceInitFormatted}}</h1>
            <div class="actions">
              <div class="button-outline" (click)="cardExtend[0]=!cardExtend[0]" *ngIf="!cardExtend[0]">Send</div>
              <div class="button-outline" (click)="cardExtend[0]=!cardExtend[0]" *ngIf="cardExtend[0]">Close</div>
            </div>
          </div>
          <div class="action-extension">
            <div class="divider"></div>
            <div class="inputs">
              <input type="text" placeholder="0x00000..." required id="kmonwallet" name="kmonwallet"
                [(ngModel)]="kmonWallet" #kmonwallet=ngModel (ngModelChange)="isValidAddressKmon()"
                [disabled]="isLoading[0]" />
              <input type="number" placeholder="0" required id="kmonamount" name="kmonamount" [(ngModel)]="kmonAmount"
                #kmonamount=ngModel [disabled]="isLoading[0]" />
            </div>
            <div class="actions">
              <div class="button-gradient"
                *ngIf="!kmonamount.errors && !kmonwallet.errors && addressValidKmon && (kmonamount.value<=kmonBalanceInit) && !isLoading[0]"
                (click)="sendKmon()">Send</div>
              <div class="button-gradient disabled"
                *ngIf="kmonamount.errors || kmonwallet.errors || !addressValidKmon || (kmonamount.value>kmonBalanceInit)">
                Send</div>
              <div class="button-gradient" *ngIf="isLoading[0]">
                <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
              </div>
              <div class="button-gradient" *ngIf="successTx[0]">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="card wallet-card" [ngClass]="{'extend': cardExtend[1]}">
          <div class="balance-content">
            <img src="./assets/img/Icon/Cur-BNB.png" />
            <h1 class="title-gradient gradient-yo">{{bnbBalanceInitFormatted}}</h1>
            <div class="actions">
              <div class="button-outline" (click)="cardExtend[1]=!cardExtend[1]" *ngIf="!cardExtend[1]">Send</div>
              <div class="button-outline" (click)="cardExtend[1]=!cardExtend[1]" *ngIf="cardExtend[1]">Close</div>
            </div>
          </div>
          <div class="action-extension">
            <div class="divider"></div>
            <div class="inputs">
              <input type="text" placeholder="0x00000..." required id="bnbwallet" name="bnbwallet"
                [(ngModel)]="bnbWallet" #bnbwallet=ngModel (ngModelChange)="isValidAddressBnb()"
                [disabled]="isLoading[1]" />
              <input type="number" placeholder="0" required id="bnbamount" name="bnbamount" [(ngModel)]="bnbAmount"
                #bnbamount=ngModel [disabled]="isLoading[1]" />
            </div>
            <div class="actions">
              <div class="button-gradient"
                *ngIf="!bnbamount.errors && !bnbwallet.errors && addressValidBnb && (bnbamount.value<=bnbBalanceInit) && !isLoading[1]"
                (click)="sendBnb()">Send</div>
              <div class="button-gradient disabled"
                *ngIf="bnbamount.errors || bnbwallet.errors || !addressValidBnb || (bnbamount.value>bnbBalanceInit)">
                Send
              </div>
              <div class="button-gradient" *ngIf="isLoading[1]">
                <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
              </div>
              <div class="button-gradient" *ngIf="successTx[1]">
                <fa-icon [icon]="['fas', 'check']"></fa-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="transactions-section">
      <div class="col-lg-6 col">
        <div class="card transactions-card">
          <div class="tx-item" *ngFor="let tx of walletTransactions">
            <div class="tx-logo">
              <img src="./assets/img/Home/k-logo.png" *ngIf="tx.currency=='KMON'" />
              <img src="./assets/img/Icon/Cur-BNB.png" *ngIf="tx.currency=='BNB'" />
            </div>
            <div class="tx-text">
              <div class="usd-kmon">
                <h1>{{tx.amountFormatted}}</h1>
                <div class="divider"></div>
                <h1>{{tx.usdFormatted}}</h1>
              </div>
              <p>{{tx.date}} - {{tx.addressShown}}</p>
            </div>
            <div class="tx-actions">
              <fa-icon [icon]="['fas', 'arrow-circle-up']" *ngIf="tx.type=='Out'" class="red"></fa-icon>
              <fa-icon [icon]="['fas', 'arrow-circle-down']" *ngIf="tx.type=='In'" class="green"></fa-icon>
              <fa-icon [icon]="['fas', 'search']" (click)="exploreTx(tx.txHash)"></fa-icon>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col">
        <div class="card boxes-card">
          <div class="boxes-container">
            <div class="boxes-list" *ngIf="parsedBoxes && !isLonger">
              <div class="boxes-item" *ngFor="let pb of purchaseBoxes; let i = index"
                [ngClass]="{'selected':boxSelected[i],'shrink': (boxSelected[0] || boxSelected[1] || boxSelected[2])}">
                <img class="img-coin" src="{{pb.img}}" />
                <div class="box-content">
                  <div class="box-detail">
                    <p class="kmon-bnb"><img src="./assets/img/Home/k-logo.png" />{{pb.kmonAmountFormatted}}</p>
                    <div class="divider"></div>
                    <p class="kmon-bnb"><img src="./assets/img/Icon/Cur-BNB.png" />{{pb.bnbAmount}}</p>
                  </div>
                  <div class="box-payment">
                    <div class="price-item">
                      <p class="usd-value">${{pb.totalValue}}</p>
                    </div>
                    <div class="actions">
                      <div class="button-outline" (click)="initPurchase(i)"
                        *ngIf="!isSimplexLoading[i] && !isSimplexSuccess[i]">Buy</div>
                      <div class="button-gradient" *ngIf="isSimplexLoading[i]">
                        <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
                      </div>
                      <div class="button-gradient" *ngIf="isSimplexSuccess[i]">
                        <fa-icon [icon]="['fas', 'check']"></fa-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="is-longer" *ngIf="isLonger">
              <h1>Koagea Connection Latency...</h1>
              <p>Looks like the BNB will require a bit more time to arrive, this can be due to a latency on the
                blockchain
                or, in case you have been asked to provide your ID, due to ID check. You'll receive an email as soon as
                your BNB will be sent to your wallet, so then you'll be able to come back here and get your KMONs</p>
              <h1>In case you will not receive any email from Simplex in an hour or so, feel free to contact us!</h1>
            </div>
          </div>
        </div>
        <div class="card allowances-card">
          <div class="allowance-item">
            <div class="allowance-item-text">
              <h1>Buy Kryptomons</h1>
              <p *ngIf="bnbBalanceInit>0">Enable the wallet to buy Kryptomons on the Marketplace.</p>
              <p *ngIf="bnbBalanceInit==0">You need to refill your wallet.</p>
            </div>
            <div class="allowance-toggle">
              <label class="switch" *ngIf="!loadingAllowances[0]">
                <input type="checkbox" [disabled]="bnbBalanceInit==0" [(ngModel)]="hasKmonAllowance"
                  (ngModelChange)="allowanceRouter(hasKmonAllowance,0)">
                <span class="slider round"></span>
              </label>
              <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin" *ngIf="loadingAllowances[0]"></fa-icon>
            </div>
          </div>
          <div class="allowance-item">
            <div class="allowance-item-text">
              <h1>Sell Kryptomons</h1>
              <p *ngIf="bnbBalanceInit>0">Enable the wallet to sell Kryptomons on the Marketplace.</p>
              <p *ngIf="bnbBalanceInit==0">You need to refill your wallet.</p>
            </div>
            <div class="allowance-toggle">
              <label class="switch" *ngIf="!loadingAllowances[1]">
                <input type="checkbox" [disabled]="bnbBalanceInit==0" [(ngModel)]="hasNFTAllowance"
                  (ngModelChange)="allowanceRouter(hasNFTAllowance,1)">
                <span class="slider round"></span>
              </label>
              <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin" *ngIf="loadingAllowances[1]"></fa-icon>
            </div>
          </div>
          <div class="allowance-item">
            <div class="allowance-item-text">
              <h1>Bidding</h1>
              <p *ngIf="bnbBalanceInit>0">Enable the wallet to bid on Kryptomons using the KMON.</p>
              <p *ngIf="bnbBalanceInit==0">You need to refill your wallet.</p>
            </div>
            <div class="allowance-toggle">
              <label class="switch" *ngIf="!loadingAllowances[2]">
                <input type="checkbox" [disabled]="bnbBalanceInit==0" [(ngModel)]="hasBiddingAllowance"
                  (ngModelChange)="allowanceRouter(hasBiddingAllowance,2)">
                <span class="slider round"></span>
              </label>
              <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin" *ngIf="loadingAllowances[2]"></fa-icon>
            </div>
          </div>
          <div class="allowance-item">
            <div class="allowance-item-text">
              <h1>Buy Lootboxes</h1>
              <p *ngIf="bnbBalanceInit>0">Enable the wallet to buy in game Lootboxes.</p>
              <p *ngIf="bnbBalanceInit==0">You need to refill your wallet.</p>
            </div>
            <div class="allowance-toggle">
              <label class="switch" *ngIf="!loadingAllowances[3]">
                <input type="checkbox" [disabled]="bnbBalanceInit==0" [(ngModel)]="hasLootboxesAllowance"
                  (ngModelChange)="allowanceRouter(hasLootboxesAllowance,3)">
                <span class="slider round"></span>
              </label>
              <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin" *ngIf="loadingAllowances[3]"></fa-icon>
            </div>
          </div>
          <div class="allowance-item">
            <div class="allowance-item-text">
              <h1>Breeding</h1>
              <p *ngIf="bnbBalanceInit>0">Enable the wallet to execute breeding.</p>
              <p *ngIf="bnbBalanceInit==0">You need to refill your wallet.</p>
            </div>
            <div class="allowance-toggle">
              <label class="switch" *ngIf="!loadingAllowances[4]">
                <input type="checkbox" [disabled]="bnbBalanceInit==0" [(ngModel)]="hasBreedingAllowance"
                  (ngModelChange)="allowanceRouter(hasBreedingAllowance,4)">
                <span class="slider round"></span>
              </label>
              <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin" *ngIf="loadingAllowances[4]"></fa-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="simplexWidget" [ngClass]="{'hide': !showWidget}">
    <form id="simplex-form">
      <div id="checkout-element">
        <!-- checkout will be rendered here -->
      </div>
    </form>
    <div class="buttons">
      <div class="button-outline" (click)="closeSimplex()">Cancel</div>
    </div>
  </div>

  <!-- [src]="'https://buy.onramper.com/?'+convertJSONToQueryParam" -->
  <!-- src="https://buy.onramper.com/?apiKey=pk_prod_01H0ME3CQW1ECHXFEFPKW6QT9B&onlyCryptos=BNB_BSC&defaultAmount=100&defaultFiat=USD" -->
  <div class="overlay" *ngIf="showOnramper" (click)="closeOnramper()">
    <iframe style="border-radius: 4px; border: 1px solid #58585f; margin: auto;max-width: 420px" [src]="srcOnramper"
      height="630px" width="420px" title="Onramper widget" allow="accelerometer; autoplay; camera; gyroscope; payment"
      class="iframe-onramper">
    </iframe>
    <!-- <div class="onramper-close-button">
      <div class="button-outline" (click)="showOnramper = false">Cancel</div>
    </div> -->
  </div>
</div>